import gql from 'graphql-tag';
const PUZZLE_PIECES_ACTIVITY_FRAGMENT = gql `
  fragment PuzzlePiecesActivityFragment on PuzzlePiecesActivity {
    numberOfCards
    rounds {
      roundIndex
      steps {
        stepIndex
        name
        audio
        order
        images {
          main
          letter
          puzzlePiece {
            x
            y
            full
            width
            missing
          }
        }
      }
    }
  }
`;
export default PUZZLE_PIECES_ACTIVITY_FRAGMENT;
